import { render, staticRenderFns } from "./FilterConsentsDialog.vue?vue&type=template&id=12189a17&scoped=true&"
import script from "./FilterConsentsDialog.vue?vue&type=script&lang=js&"
export * from "./FilterConsentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12189a17",
  null
  
)

export default component.exports